enum Orientation {
    vertical = "vertical",
    horizontal = "horizontal",
}

export default Orientation
